import React, { useEffect, useState } from "react";
import { Container, Card, Button } from 'react-bootstrap';
import arrowLeft from "../assets/images/arrow-left.png";
import calendarGreen from "../assets/images/calendar_green.png";
import chat from "../assets/images/chat.png";
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import config from '../config/config';
import { getProgramTimeSlots } from '../services/TeacherApi';
import LoadingSpinner from './LoadingSpinner';

const AttendanceTeacher = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const { id: programId } = useParams();
  const location = useLocation();
  const { skillLevelId } = location.state || {};
  const [programData, setProgramData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTimeSlots = async () => {
      try {
        const response = await getProgramTimeSlots(programId, user.user_data.id);
        setProgramData(response.data);
      } catch (error) {
        console.error("Error fetching time slots:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTimeSlots();
  }, [programId, user.user_data.id]);

  if (loading) return <LoadingSpinner />;

  return (
    <div className='app-container mobile-bottom'>
      <Container>
        <div className='breadcrum bg_light_yellow'>
          <h2 className='d-flex align-items-center mb-0 fs-20'>
            <Link to='/allocatedClasses'><img src={arrowLeft} width={18} className='me-2' alt="link" /></Link>
            Attendance Teacher</h2>
        </div>
        <div className="mt-3">
          <h2 className='fs-20 fw-6 mb-1'>
            <span className='small-hello fs-14'>Hello, </span>
            <span className='bigg-name'>{user?.user_data.name}!</span>
          </h2>
          <p>Select class for Attendance & Feedback</p>

          <div className='attendance mb-4 rounded-3'>
            {programData?.time_slots.map((slot, index) => (
              slot.skill_level_id === skillLevelId &&
              <Card key={index} className='mb-0 p-3'>
                <Card.Body className='d-flex align-items-center p-0'>
                  <div className='program_img me-2'>
                    <img src={`${config.Image_Base_URL}${slot.image}`} alt='program' width={100} />
                  </div>
                  <div className='program_content w-100'>
                    <Card.Title className='mb-1 fs-14 fw-6'>
                      {slot.program_name} - {slot.skill_level_name} Level
                    </Card.Title>
                    <div className='fs-11 fw-5 mb-1'>{slot.focus?.title}</div>
                    <Card.Text className='mb-2 fs-12'>
                      <div key={index}>{slot.start_time} - {slot.end_time}</div>
                    </Card.Text>
                    <Card.Subtitle className='text-muted fs-12'> {slot.day_name}</Card.Subtitle>
                  </div>
                  <div className="d-flex">
                    <Button variant="unknown" size='sm' onClick={() => navigate(`/attendance`, { state: { slot } })} className="p-0 me-1" type="button"><img src={calendarGreen} width={25} alt="text" /></Button>
                    <Button variant="unknown" size='sm' onClick={() => navigate(`/teacherFeedback`, { state: { slot } })} className="p-0"><img src={chat} width={25} alt="text" /> </Button>
                  </div>
                </Card.Body>
              </Card>
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
}

export default AttendanceTeacher;